<template>
  <DBox
    :id="'cmp-accounting-costs-cost_sidewindow-payments'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('payment')}`"
    @addClick="onAddClick"
  >
    <NTable
      class="invoice-list"
      :headers="headers"
      :items="list"
       :showNoItems="false"
      :config="tableConfig"
      :id="'accounting-cost-cost_sidewindow-payments dbox1'"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('payment_date_string')">
            <DatePicker2
              id="date"
              :label="$t('payment_date_string')"
              :showLabel="false"
              :value="item['date']"
              :bb="'0px'"
              @input="(e) => onDateUpdate(e, item)"
            />
          </td>
          <td v-bind="tdcon('options2')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :options="debitCreditTV"
              :selected="
                debitCreditTV.find((e) => e.value == item.debit_credit)
              "
              :placeholder="$t('costgroup')"
              v-on:selectedChange="
                (e) => onDropdownChange('debit_credit', e, item)
              "
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('amount')">
            <TextField2
            class="dbox1"
              :id="'amount'"
              :ta="'right'"
              :showLabel="false"
              :value="item['amount']"
              @blur="(e) => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('currency')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="selectedCostsDetails.disabled"
              :options="selectedCostsDetails.currenciesTV"
              :selected="
                selectedCostsDetails.currenciesTV.find(
                  (v) => v.value == item.currency_id
                )
              "
              v-on:selectedChange="
                (e) => onPaymentCurrencyChange('currency_id', e, item)
              "
              :bb="'0px'"
            ></Dropdown2>
          </td>
          <td v-bind="tdcon('exchangerate')">
            <TextField2
            class="dbox1"
              :id="'exchangerate'"
              :showLabel="false"
              :ta="'right'"
              :value="item['exchangerate']"
              @blur="(e) => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('total')">
            <span style="text-align: right"
              >{{ getAmountInDefaultCurr(item) }}
              {{ $store.getters.account.client.default_currency }}
            
            </span>
          </td>
          <td v-bind="tdcon('money_account')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :options="moneyAccountTV"
              :selected="
                moneyAccountTV.find((e) => e.value == item.money_account_id)
              "
              :placeholder="$t('money_account')"
              v-on:selectedChange="
                (e) => onDropdownChange('money_account_id', e, item)
              "
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => deleteCost(item)"
              class="dt-icon s2 v5"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
    <template slot="bottomRight">
      <div class="ut-flex ut-fh ut-mr-10px">
        <div class="local-details-confirmed">
          <!-- <div class="label">Local Details Confirmed</div> -->
          <div style="margin: 0px" class="checkbox">
            <div class="dt-checkbox v2 s1">
              <input
                :id="'paid_flag'"
                @click="(e) => oncheckboxChange(e)"
                :name="'paid_flag'"
                :checked="invoice && invoice.paid_flag == 1"
                type="checkbox"
              />
              <div class="checkmark"></div>
            </div>
          </div>
        </div>
        <div class="status">
          <span
            class="circle-status"
            :style="{
              backgroundColor:
                invoice && invoice.paid_flag == 1
                  ? `#64C896`
                  : `#ccc`,
            }"
          ></span>
          <span>{{$t('fully_paid')}}</span>
        </div>
        <DatePicker2
          v-if="invoice && invoice.paid_flag == 1"
          id="payment_date"
          :label="$t('Pay Date')"
          :showLabel="false"
          :value="invoice.payment_date"
          :bb="'0px'"
          style="height:26px"
          @input="(e) => onPaidDateUpdate(e)"
        />
      </div>
    </template>
  </DBox>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { CostsService } from "../../services/costs.service";
import { createTableHeader } from "../../../../plugins/datatable";
import { createTV, tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  components: {
    NTable,
    DBox,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      invoiceHeaders: [],
      payments: [],
      moneyAccounts: [],
      paidDate: null,
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
      selectedStatus: null,
      debitCreditTV: [
        { text: "+", value: "1" },
        { text: "-", value: "-1" },
      ],
      invoiceDateMenu: null,
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("payment_date_string"),
        createTableHeader("options2", { text: "+/-", }),
        createTableHeader("amount", { ta: "right" }),
        createTableHeader("currency"),
        createTableHeader("exchangerate", { ta: "right" }),
        createTableHeader("total", { text: this.$t('total_eur'), ta: "right" }),
        createTableHeader("money_account"),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    list: function () {
      return this.selectedCostsDetails?.payments || [];
    },
    
    invoice: function () {
      return this.selectedCostsDetails?.invoice || {};
    },
    moneyAccountTV: function () {
      return createTV(
        this.selectedCostsDetails?.money_accounts,
        "money_account_name",
        "money_account_id"
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onPaidDateUpdate: function ({ name, value }) {
      console.log({ name, value });
      this.$emit("changed_invoice", {
        name,
        value,
      });
    },
    getAmountInDefaultCurr: function (item) {
      return this.$dft.curr(
        ((item.debit_credit ? item.debit_credit : 1) * item.amount) /
          (item.exchangerate ? item.exchangerate : 1)
      );
    },
    oncheckboxChange: function (e) {
      let flag = e.target.checked ? 1 : 0;
      this.$emit("changed_invoice", {
        name: "paid_flag",
        value: flag,
      });
    },
    onPaymentCurrencyChange: function (name, value, item) {
      this.$emit("currency_changed", { name, value: value.value, item });
    },
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", { name, value: value, item });
      //this.updateData(item);
    },
    onDropdownChange: function (name, value, item) {
      item[name] = value.value;
      this.$emit("changed", { name, value: value.value, item });
     // this.updateData(item);
    },

    onDateUpdate: function ({ name, value }, item) {
      item[name] = value;
      this.$emit("changed", {
        name,
        value,
        kVal: item.payment_id,
        table: "payments",
      });
      //this.updateData(item);
    },
    updateData: function (item) {
      const payments = this.selectedCostsDetails.payments.map((b) => {
        if (b.payment_id === item.payment_id) {
          b = {
            ...item,
          };
        }
        return b;
      });

      this[ActionTypes.AccountingCostPayments.SET.ALL]({
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        payments: payments || [],
      });
    },
    deleteCost: async function (item) {
      const confirmationResult = await confirmDelete(
        "payments",
        item.royalty_account_name
      );
      if (confirmationResult === "OK") {
        const res = await CostsService.costPaymentsDelete(item.payment_id);
        const payments = this.selectedCostsDetails.payments.filter(
          (b) => b.payment_id !== item.payment_id
        );
        this[ActionTypes.AccountingCostPayments.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          payments: payments || [],
        });
      }
    },
    onAddClick: function () {
      CostsService.costPaymentsAdd(
        this.selectedCostsDetails?.invoice?.invoice_id
      ).then((res) => {
        const payments = res.data.payments;
        this[ActionTypes.AccountingCostPayments.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          payments: payments || [],
        });
      });
    },
  },
};
</script>


<style lang="scss">
.cmp-accounting-costs-cost_sidewindow-payments {
  .fc2-datepicker .menu .menu__activator .date-control {
    background: none;
    border: none;
  }
  .status {
    // flex: 1;
    display: flex;
    align-items: center;
    max-width: 150px;
    padding: 0px 5px;
    .circle-status {
      margin-right: 10px;
    }
    .status-name {
      flex: 1;
    }
  }
}
</style>
